<template>

  <div class="text-content shadow-more">

    <!-- 左边 -->
    <div class="text-content-left"
         v-loading="textLoading"
         element-loading-background="#f9fbfe"
         element-loading-text="文本识别中……"
    >
      <!-- 左边-头部 -->
      <div class="text-content-left-head">
        <button class="example-btn" @click="getExample(0);anlaData()">样例1</button>
        <button class="example-btn" @click="getExample(1);anlaData()">样例2</button>
        <button class="example-btn" @click="getExample(2);anlaData()">样例3</button>
<!--        <img style="height: 30px" src="@/assets/pic/book.png" alt="1">-->
      </div>
      <!-- 左边-内容区 -->
      <div class="text-content-left-content">
        <textarea v-if="!isAnalyzing"  class="text-content-left-content-textarea" v-model="textContent" placeholder="请输入内容或上传文本文件..."
          ></textarea>
        <div v-if="isAnalyzing" class="text-content-left-content-textarea-highlighted">
          <span  v-html="highlightedText" ></span>
        </div>
      </div>
      <!-- 左边-底部 -->
      <div class="text-content-left-footer">

        <div class="text-delete-btn">
          <button class="delete-btn" @click="clearText();initIsAnalyzing()">
            <img src="@/assets/icon/delete.png" alt="icon" class="delete-icon">
          </button>
        </div>

          <span class="count-text">{{ countText }} /1200words</span>
          <!--          <el-button class="el-footer-btn" type="primary" plain round>主要按钮</el-button>-->
          <button class="upload-btn" @click="selectFile();initIsAnalyzing()">
            <div class="upload-text-container">
              <span class="upload-text">上传文本 <img src="@/assets/icon/upload.png" alt="icon" class="upload-icon"></span>
              <span class="upload-extension">(.doc,.docx,.txt)</span>
            </div>

          </button>

           <button class="text-analysis-btn" style="margin-left: 0" @click="anlaData();">文本分析</button>
          <input type="file" ref="fileInput" @change="handleFileChange" accept=".doc,.docx,.txt" style="display: none" />

      </div>
    </div>
    <!-- 右边 -->

<!--    <template  v-if="isResult">-->

    <div class="text-content-right"

     v-loading="loading===true"
      element-loading-background="#f9fbfe"
      element-loading-text="风险内容检测中……"

      >

<template v-if="loading===false">
        <!-- 右边-上方 -->
        <div class="text-content-right-up">
          <div class="text-content-right-up-text">

            <div class="text-content-right-text-up" >
              <el-alert
                  v-if="countText <= 50"
                  description="由于输入句子较短，AI生成检测可能存在错漏"
                  type="warning"
                  center
                  :closable="false"
                  show-icon>
              </el-alert>
                <el-alert
                  v-else-if="aiScore < 50"
                  description="你输入的内容AI生成可能性低"
                  type="success"
                  center
                  :closable="false"
                  show-icon>
                </el-alert>
                <el-alert
                  v-else-if="aiScore >= 50"
                  description="你输入的内容似乎是由AI生成的"
                  type="warning"
                  center
                  :closable="false"
                  show-icon>
                </el-alert>
            </div>
            <CircleProgress v-if="loading===false" :size="120" :progress="aiScore" style="margin-top: 15px"></CircleProgress>

          </div>

        </div>
        <!-- 右边-下方 -->

        <div class="text-content-right-down">
<!--          <template v-if="resultData.type === 'error'">-->

          <div class="summary" >
            <div class="text-content-right-down-title">文本内容概括</div>
            <div class="text-summary" v-html="contentSummary"></div>
            <el-skeleton v-if="!contentSummary" :rows="3" animated />
          </div>

            <div class="summary" style="margin-top: 15px">
              <div class="text-content-right-down-title">文本风险概括</div>
              <div class="text-summary" v-html="riskSummary"></div>
              <el-skeleton v-if="!riskSummary" :rows="3" animated />
            </div>

            <div class="summary" style="margin-top: 15px">

            <div class="text-content-right-down-title  ">文本风险信息</div>
              <el-alert
                  v-if="noRisk"
                  style="margin-top: 10px"
                  title="文本无风险内容"
                  type="success"
                  center
                  :closable="false"
                  show-icon>
              </el-alert>

            <el-skeleton v-if="this.noRisk==null" animated rows="4"></el-skeleton>


            <div v-else class="text-content-right-down-list">
              <el-collapse accordion>
                <el-collapse-item v-for="(risk,index) in risks" :key="index">
                  <template slot="title">
                    <div class="text-content-right-down-list-item" :style="{ animationDelay: (index * 0.15) + 's' }">
                      <div style="display: flex;align-items: center">
                      <span class="content" style="color: #606266">
                        {{risk.text}}

                      </span>
                      </div>
                      <span class="tag">
                    <el-tag type="danger">{{ risk.risk_type }}</el-tag>
                  </span>
                    </div>
                  </template>
                  <div style="padding: 0 10px;font-size: 15px;display: flex;flex-direction: column">

                    <div class="flex" style="border-top: #97b2e9 1px solid;">
                      <div style="width: 20%;margin-right: 5px"><strong >文本:</strong></div>    <div style="width: 80%">{{risk.text}}</div>
                    </div>
                    <div class="flex">
                      <div style="width: 20%;margin-right: 5px"><strong >风险类型:</strong></div>    <div>{{risk.risk_type}}</div>

                    </div>
                    <div class="flex">
                      <div style="width: 20%;margin-right: 5px"><strong >恶意程度:</strong></div>    <div>{{risk.malicious_degree}}</div>

                    </div>

                    <div style="margin-top: 5px">{{risk.analysis}}</div>
                  </div>

                </el-collapse-item>


              </el-collapse>

<!--              <div v-for="(item, index) in resultData.list" :key="index">-->
<!--                <div class="text-content-right-down-list-item" :style="{ animationDelay: (index * 0.15) + 's' }">-->
<!--                  <span class="content">{{ item.content }}</span>-->
<!--                  <span class="tag">-->
<!--                    <el-tag type="danger">{{ item.type }}</el-tag>-->
<!--                  </span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <feedback-btns icontype="iconfont icon-copy"></feedback-btns>-->

            </div>

            </div>

        </div>
      </template>
      <!-- 右边-初始界面 -->
      <template v-if="loading===null">
        <div class="text-content-right-init">
          <div class="text-content-right-init-up">
            <img src="@/assets/icon/robot.png" alt="icon" class="robot-icon">
            <span class="text-content-right-init-up-text">检测结果将显示在这里</span>
          </div>
          <div class="text-content-right-init-middle">
            <span>文本内容和风险概述</span>
          </div>
          <div class="text-content-right-init-down">
            <span>文本风险信息</span>
          </div>
        </div>
    </template>
    </div>
  </div>
</template>

<script >
import countTo from 'vue-count-to';
import feedbackBtns from "@/components/feedbackBtns.vue";
import CircleProgress from '@/components/CircleProgress.vue';
export default {


  components: { countTo,feedbackBtns, CircleProgress},
  data() {
    return {
      isResult:false,
      textLoading : false,
      fileType:null,
      selectedFile: null,
      // modelSummary:"",
      contentSummary:"",
      riskSummary:"",
      percentage: 10,
      risks:[],
      noRisk:null,
      colors: [

        {color: '#5cb87a', percentage: 40},
        {color: '#e5ca6f', percentage: 60},

        {color: '#ce5252', percentage: 80},
        {color: '#ec4c4c', percentage: 90},
        {color: '#f84141', percentage: 100}
      ],
      aiScore :0,
      loading:null,
      textContent: "",
      samText:[


          "“My life is very monotonous ,” the fox said. “I hunt chickens; men hunt me. All the chickens are just alike, and all the men are just alike. And, in consequence, I am a little bored. But if you tame me, it will be as if the sun came to shine on my life. I shall know the sound of a step that will be different from all the others. Other steps send me hurrying back underneath the ground. Yours will call me, like music, out of my burrow . And then look: you see the grain-fields down yonder ? I do not eat bread. Wheat is of no use to me. The wheat fields have nothing to say to me. And that is sad. But you have hair that is the colour of gold. Think how wonderful that will be when you have tamed me! The grain, which is also golden, will bring me back the thought of you. And I shall love to listen to the wind in the wheat... ”\n" +
          "The fox gazed at the little prince, for a long time. “Please—tame me!” he said.\n" +
          "“I want to, very much,” the little prince replied. “But I have not much time. I have friends to discover, and a great many things to understand.”\n" +
          "“One only understands the things that one tames,” said the fox. “Men have no more time to understand anything. They buy things all ready made at the shops. But there is no shop anywhere where one can buy friendship, and so men have no friends any more. If you want a friend, tame me... ”",


         "This is another personal attack about you being a massive donkey dick sucking homosexual. This is a concerned plea that you should at once drown yourself in a sewer. Fucking fuck off you fag! And if you threaten me with legal action again, I'll fucking come over there, tie you to your computer chair and stick my cock up your arse until it bleeds. You fucker!!",


          "Alice had always loved the thrill of amusement parks, so when she found herself with a free weekend, she decided to visit one nearby. The morning was bright and sunny as she walked through the gates of Wonderland Park, the sounds of laughter and the smell of cotton candy filling the air."
      ],
      resultData: {},
      textErrorSrc: require('@/assets/pic/error-robot.svg'),
      textSuccessSrc: require('@/assets/pic/text-success.png'),
      isAnalyzing: false,
    }
  },
  mounted() {



  },
  methods: {
    selectFile() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file ){

        const fileType = file.type;
        let fileExtension = file.name.split('.').pop().toLowerCase();

        if (fileType === 'application/msword' ||
          fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          fileType === 'text/plain' ||
          fileExtension === 'doc' ||
          fileExtension === 'docx' ||
          fileExtension === 'txt') {
          this.selectedFile = file;
          if (fileExtension === 'doc' ||
            fileExtension === 'docx' ){fileExtension = 'word'}

          this.fileType = fileExtension;
          this.textLoading = true
          this.uploadFile();
        }
      } else {
        this.$message.error('请上传 Word 或 TXT 文件');
        this.$refs.fileInput.value = ''; // 清空选择的文件
        this.fileType = null;
      }
    },
    async uploadFile() {

      if (!this.selectedFile) {
        this.$message.warning('请先选择所需上传的文件');
        return;
      }
      try {
        // 使用 await 等待异步操作完成
        // this.loading = true;
        let timestamp = Date.now();
        const additionalData = { type: 'text', timestamp: timestamp };
        const resFile = await this.apis.uploadFile(this.selectedFile, additionalData);
        console.log(resFile.data.message);
        if (resFile.data.message === '文件上传成功') {
          let filePath = resFile.data.filePath
          // this.$message.success('文件上传成功');
          this.fileToText(filePath);
        }
      } catch (error) {
        this.$message.error('文件上传失败');
        console.error('上传失败:', error);
      } finally {
        this.fileLoading = false;
        // this.loading = false
      }
    },

    fileToText(filePath) {
      this.apis.parseTextFile({
        type: this.fileType,
        filePath:filePath
      })
        .then(res => {
          this.textContent = res.text

        })
        .catch(err => {
          console.log()
          this.$notify.error({
            title: '系统错误，请联系管理员。',
            message: err
          });
        })
        .finally(()=>{
          this.textLoading=false
        })
        ;
    },

    anlaData() {

      this.loading = true
      this.isResult = true
      this.isAnalyzing =true;

      //发送文本给后台
      if( this.textContent ===''){
        this.$message.warning('请输入文本');
        this.isResult = false;
        this.loading = null;
        return;
      }

      this.apis.textAIDetect({
        text:this.textContent
      })
        .then(res => {
          console.log(res)
          this.loading = false
          setTimeout(()=>{
            this.aiScore = Math.floor(Number(res.score) * 1000) / 10;

          },500)

        })
        .catch(err => {
          this.loading = false
          console.log()
          // this.loading = false
          this.$notify.error({
            title: '文本ai接口出错',
            message: err
          });
        });

      let newText = this.textContent.replace(/\n/g, '\\n ');
      this.apis.modelResult({
        name:"textRiskSummary",
        fileName: "",
        fileTimestamp: "",
        text:newText,
      })
          .then(res => {
            this.contentSummary= this.getMessage(res.content_summary)
            this.riskSummary = this.getMessage(res.risk_summary)

            this.risks = res.risk
            this.noRisk = this.risks.length === 0;
            console.log(this.risks)

          })
          .catch(err => {
            console.log()
            this.$notify.error({
              title: '大模型接口错误',
              message: err
            });
          });




    },
    getMessage(content) {
      //加g是替换字符串里出现的所有\n，不加g是替换字符串里出现的第一个\n
      content =  content.replace(/(###\s+([^\s]+))|(\*\*(.*?)\*\*|\n)/g, (match, p1, p2, p3, p4) => {
        if (match === '\n') {
          return '<br/>';
        } else if (p1) {
          // 处理###加粗文本
          return '<strong >' + p2 + '</strong><br/>';
        } else if (p3) {
          // 处理**加粗文本
          return '<strong>' + p4 + '</strong>';
        }

        return match;
      });
      content = content.replace(/(<br\/>\s*){3,}/g, '<br/><br/>');
      return content
    },
    //初始化高亮框不展示
    initIsAnalyzing(){
      this.isAnalyzing =false;
    },
     highlightMatchedContent(content) {
      const regex = new RegExp(content, 'gi');
      return this.textContent.replace(regex, (match) => `<span class="highlighted">${match}</span>`);
    },
    getExample(index) {
      this.clearText()
      this.textContent = this.samText[index]
    },
    clearText() {
      this.textContent = "";
      this.isResult = false
      this.loading = null
      // this.modelSummary = ''
      this.contentSummary=""
          this.riskSummary=""
      this.aiScore = 0
      //演示案例
      this.resultData = {};
      this.risks = []
      this.noRisk = null

    },
    uploadText() {

    },
  },
  computed: {
    //高亮匹配文本
    highlightedText() {
      let highlighted = this.textContent.replace(/\n/g, '<br>'); // 将换行符转换为 <br>
      this.risks.forEach(item => {
        const regex = new RegExp(item.text, 'gi');
        highlighted = highlighted.replace(regex, (match) => `<span class="highlighted">${match}</span>`);
      });
      return highlighted;
    },
    //统计文本字数
    countText() {
      let total = 0;
      // 统计英文单词个数
      const englishWordMatches = this.textContent.match(/\b[a-zA-Z]+\b/g);
      total += englishWordMatches ? englishWordMatches.length : 0;
      // 统计中文字数
      const chineseCharacterMatches = this.textContent.match(/[\u4e00-\u9fa5]/g);
      total += chineseCharacterMatches ? chineseCharacterMatches.length : 0;
      // 统计数字个数
      const numberMatches = this.textContent.match(/\d+/g);
      total += numberMatches ? numberMatches.length : 0;
      // 返回所有元素的总和
      return total;
    }
  },
}
</script>

<style >
.text-content {
  display: flex;
  height: 65vh;
  background-color: #F9FBFE;
  width: 77vw;
  border-radius: 35px;
  padding: 20px;
}

.

.el-loading-spinner .el-loading-text  {
  font-size: 20px ;

}

.shadow-more {
 box-shadow:  0 0 3px 4px #c0c4cc45;
}

.el-progress__text {
  font-size: 33px !important;
}


.text-content-left {
  border-right: 1px solid #91aee8;;
  padding: 0 10px;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
}

.text-content-left-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 8%;
  margin-bottom: 5px;
}

.model-text {
  color: #c3c7d6;
  font: 10px;
  font-weight: bold;
}

.model-label {
  margin-left: 10px;
  color: #2c2d35;
  font-size: 18px;
  font-weight: 900;
}

.text-content-left-content {
  text-align: justify;
  height: 80%;
  width: 100%;
}
.text-content-left-content-textarea {
  border-color: #ccc;
  text-align: justify;
  border-radius: 15px;
  line-height: 1.8;
  width: 95%;
  height: 95%;
  overflow-y: auto;
  resize: none;
  font-size: 16px;
  padding: 10px;
  font-family: "Microsoft YaHei", serif;
  clip-path: inset(0 round 15px);
}

.text-content-left-content-textarea::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.text-content-left-content-textarea::-webkit-scrollbar-track {
  border-radius: 1px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}

.text-content-left-content-textarea::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}

.text-content-left-content-textarea-highlighted {
  border-color: #ccc;
   border-width: 1px;
  border-style: solid;
  border-radius: 15px;
  line-height: 1.8;
  width: 95%;
  height: 95%;
  overflow-y: auto;
  resize: none;
  font-size: 16px;
  padding: 10px;
  font-family: "Microsoft YaHei", serif;
  clip-path: inset(0 round 15px);
}

.text-content-left-content-textarea-highlighted::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.text-content-left-content-textarea-highlighted::-webkit-scrollbar-track {
  border-radius: 1px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}

.text-content-left-content-textarea-highlighted::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}



.text-content-left-footer {
  display: flex;
  align-items: center;
  height: 10%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
}

.flex {
  display: flex;
  margin-top: 5px;
}


.delete-btn {
  flex:1;
  border: none;
  background-color: transparent;
  padding: 0;
  width: auto;
  height: auto;
  //margin-right: 8px;
  cursor: pointer;
}

.delete-btn .delete-icon {
  width: 24px;
  height: 24px;
}

.count-text {
  flex:3;
  color: #909399;
  font-size: 15px;
  font-weight: bold;
  align-items: center;
}

.upload-btn {
  margin-left: 10px;
  margin-right: 10px;
  flex:3;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center; /* 确保内容垂直居中 */

}
.upload-text-container:hover {
  background-color: #e4e7edc2;
}
.upload-text-container {
  border-radius: 10px;
  /* background-color: #e4e7edc2; */
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  cursor: pointer;
  padding: 5px 10px;
  transition: background-color 0.15s ease;
}

.upload-btn .upload-text {
  display: flex;
  font-weight: bold;
  font-size: 14px;
  color: #470790;
  align-items: center;
}

.upload-btn .upload-extension {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.upload-icon {
  width: 24px;
  height: 24px;
}
.el-collapse-item:hover {
  box-shadow: 0px 0px 3px rgb(0 0 0 / 20%);
}
.text-analysis-btn:hover {
  background-color: #470790cc;
  box-shadow: 0 0 3px #6633a1;
}
.text-analysis-btn {
  margin-left: 10px;
  margin-right: 0.3vw;
  border-radius: 9px;
  font-weight: bold;
  flex:3;
  height: 100%;
  border: none;
  background-color: #470790;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  transition: all ease 0.15s;
}

.example-btn:hover {
  background-color: #6b9cf8c9;
  box-shadow: 0 0 2px #7981a2;
}
.example-btn {
  margin: 0 10px 10px 0;
  height: 15px;
  background-color: #aecbfe;
  border-radius: 9px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-family: Inter, Helvetica, "Apple Color Emoji", "Segoe UI Emoji", NotoColorEmoji, "Noto Color Emoji", "Segoe UI Symbol", "Android Emoji", EmojiSymbols, -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  padding: 5px;
  width: 20%;
  height: 30px;
  word-break: break-word;
  border: 0;
  transition:  background-color  ease 0.15s,box-shadow 0.15s ease;
}

.footer-btn:hover {
  background-color: rgb(51 83 212);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.el-footer-btn {
  width: 120px;
  height: 40px;
}

.text_transition {
  animation: colorChange 0.6s forwards;
}
.el-collapse-item__header {
  background-color: transparent !important;
  height: 60px !important;
}
.el-collapse-item__wrap {
  background-color: transparent !important;
}

@keyframes colorChange {
  from {
    color: black;
  }

  to {
    color: #d91c1cf0;
  }
}

.text-content-right-init{
  display: flex;
  flex-direction: column;
  height:100%;
}

.robot-icon{
    width:140px;
    height:140px;
}

.text-content-right-init-up{
  flex:10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.text-content-right-init-up-text{
  font-weight: bold;
  color:#c3c7d6;
}

.text-content-right-init-middle{
  flex:1;
  font-weight: bold;
  border-bottom: 1px solid #91aee8; /* 添加边界线 */

}
.text-content-right-init-down{
  flex:1;
  font-weight: bold;
  border-bottom: 1px solid #91aee8 ;
  padding-top: 20px;
  margin-bottom: 50px;
}

.text-content-right {
  padding: 0 15px;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.text-content-right::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.text-content-right::-webkit-scrollbar-track {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}

.text-content-right::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}


.summary {
  border: 1px solid #e4e7ed;
  padding: 10px;
  border-radius: 4px;
  transition: box-shadow 0.1s linear;
}

.text-content-right-up {
  //flex: 2;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 20px 0;

}


.text-content-right-up-text {
  display: flex;
  align-items: center;
  flex-direction:column;
}

.el-alert .el-alert__description {
    font-size: 16px;
    margin: 0 0 3px;
}

.text-content-right-text-up {
  font-size: 25px;
  font-weight: bolder;
}

.text-content-right-text-down {
  margin-top: 10px;

  font-weight: bolder;
}

.text-content-right-down {
  flex: 3;
  display: flex;
  flex-direction: column;

}

.text-content-right-down-title {
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: bolder;
  color: #303133;
  padding-bottom: 16px;
  border-bottom: 1px solid #91aee8;
}

.text-summary {
  line-height: 1.7;
  padding: 2px 0;
  font-size: 16px;
  text-align: justify;
}

.text-content-right-down-list {
  padding: 10px 7px;
  //max-height: 70vh;
  /* min-height: 19vh; */
  overflow-y: auto;
  overflow-x: hidden;
  //background-color: #91aee8;
  box-sizing: border-box;
  outline: none;
}

.el-collapse-item {
  box-shadow: 0px 0px 2px rgba(0, 0, 0, .12);
  margin: 3px;
  border-radius: 5px;
  margin-top: 0;
  transition: box-shadow 0.13s ease-in-out;
}


.summary:hover {
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
}
.text-content-right-down-list::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}

.text-content-right-down-list::-webkit-scrollbar-track {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}

.text-content-right-down-list::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}


.text-content-right-down-list-item {
  width: 100%;
  border: none;
  line-height: 25px;
  display: flex;
  justify-content: space-between;
  height: 7vh;
  font-size: 13px;
  //background-color: #ecf5ff;
  padding: 10px;
  align-items: center;
  /* 调整文字与边框的距离 */
  //border: 1px solid #f56c6c;
  /* 调整边框颜色 */
  //border-radius: 5px;
  /* 圆角 */
  margin: 10px 0;
  //background-color: #fef0f040;
  //opacity: 0;
  //transform: translateX(50px);
  //animation: fadeIn 0.5s forwards;
}

.text-content-right-down-list-item .content {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  padding-right: 15px;
  flex: 9;
  font-size: 15px;
  //overflow: auto;
}

.text-content-right-down-list-item .tag {

  display: flex;
  align-items: center;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.text-content-right-down-list-item .content::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.text-content-right-down-list-item .content::-webkit-scrollbar-track {
  border-radius: 1px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}

.text-content-right-down-list-item .content::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}

.text-content-right-down-success {
  font-size: 35px;
  font-weight: 500;
  margin: 50px 0 0 20px;
}

/* 高亮样式 */
.highlighted {
  color: #cb3434;
  font-weight: bolder;
}
</style>
